import { render } from "./wokerDetail8.vue?vue&type=template&id=d9fe2750&scoped=true"
import script from "./wokerDetail8.vue?vue&type=script&lang=js"
export * from "./wokerDetail8.vue?vue&type=script&lang=js"

import "./wokerDetail8.vue?vue&type=style&index=0&id=d9fe2750&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9fe2750"]])

export default __exports__